import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { displayDate } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row'
    },
    reportText:{
        color: '#000',
        letterSpacing: 1,
        fontSize: 11
    },
    reportTextUnderscore:{
        color: '#000',
        letterSpacing: 1,
        fontSize: 9,
        height: '14px',
        textIndent: '2px',
        marginTop: '-1px',
        borderBottom: '1px #000 solid',
        paddingBottom:'-2px'
    },
  });

  const OrderServiceHead = ({data}) => {
    // if(data.orderService) {
        const name = (data.orderService?.supplier && data.orderService?.supplier.name) ? data.orderService?.supplier.name : '';
        const requester = (data.orderService?.requester && data.orderService?.requester.name) ? data.orderService?.requester.name : '';
        const controlNumber = (data?.controlNumber) ? data?.controlNumber : '';
        const createdAt = (data.orderService?.createdAt) ? displayDate(data.orderService.createdAt) : '';
        const forecast = (data.orderService?.forecast) ? displayDate(data.orderService.forecast) : '';

        return (
            <>
            <View style={{...styles.titleContainer, 'marginTop': 24}}>
                <Text style={styles.reportText}>FORNECEDOR:</Text>
                <Text style={{...styles.reportTextUnderscore, width:'313px'}}>{name}</Text>
                <Text style={{...styles.reportText, marginLeft:'10px'}}>N°:</Text>
                <Text style={{...styles.reportTextUnderscore, width:'100px', textAlign:'right'}}> {controlNumber}</Text>
                
            </View>
            <View style={{...styles.titleContainer, 'marginTop': 5}}>
                <Text style={styles.reportText}>SOLICITANTE:</Text>
                <Text style={{...styles.reportTextUnderscore, width:'170px'}}>{requester}</Text>
                <Text style={{...styles.reportText, marginLeft:'10px'}}>Emissão:</Text>
                <Text style={{...styles.reportTextUnderscore, width:'75px', textAlign:'center'}}> {createdAt}</Text>
                <Text style={{...styles.reportText, marginLeft:'10px'}}>Previsão:</Text>
                <Text style={{...styles.reportTextUnderscore, width:'75px', textAlign:'center'}}> {forecast}</Text>
            </View>
            </>
        )
    // } else {
    //     return (<></>)
    // }
};
  
  export default OrderServiceHead